import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Checkbox } from 'platform/components';
import { Icon } from 'platform/foundation-tw';
import type { EagColumn } from '../../../../../../types/EagColumn';
import type { EagColumnState } from '../../../../../../types/EagColumnState';
export type SortableColumnItemProps = {
  column: EagColumn;
  columnState: EagColumnState;
  onSetHidden: (key: string, hidden: boolean) => void;
  columnHidingAllowed: boolean;
  isDragDisabled: boolean;
};
export function SortableColumnItem(props: SortableColumnItemProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({
    id: props.column.key
  });
  const isVisible = !(props.columnState.hidden ?? false);
  const dragStyle = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1
  };
  const handleCheckboxChange = (value: boolean) => {
    props.onSetHidden(props.column.key, !value);
  };
  const dragHandleProps = props.isDragDisabled ? {} : {
    ...attributes,
    ...listeners
  };
  const dragCursorClass = props.isDragDisabled ? 'cursor-default' : 'cursor-grab';
  return <div ref={setNodeRef} style={dragStyle} className="flex items-center gap-2 py-1.5 hover:bg-gray-50 rounded px-4">
      <span className={`${dragCursorClass} text-gray-400 flex-shrink-0`} {...dragHandleProps}>
        <Icon value="other/drag" size={4} />
      </span>
      <div className="flex-1 min-w-0">
        <Checkbox label={props.column.headerName} value={isVisible} onChange={handleCheckboxChange} isDisabled={!props.columnHidingAllowed} />
      </div>
    </div>;
}